exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wrapper{width:100%}.wrapper .img-circle{width:140px}.wrapper .cls-hidden{display:none}.wrapper .inner{margin:auto;max-width:400px}.cls-hidden{display:none}.custom-cbb button,.custom-cbb .dropdown-menu{width:100%;text-align:left}.cls-display-none{display:none !important}.wrapper .center-button{margin:0 auto;display:block}.float-right{float:right}.assign-subcontractor [class*=\"col-\"]+[class*=\"col-\"]{padding-left:30px}.assign-subcontractor+.table-header{z-index:unset}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Projects/project.scss
// module id = 2000
// module chunks = 33